function replaceGemstoneTextWithImages() {
  // Map gemstone names to their image URLs
  const gemstoneImages = {
    'Ruby': 'https://cdn.shopify.com/s/files/1/0736/0587/3972/files/Ruby.jpg?v=1742030665',
    'Opal': 'https://cdn.shopify.com/s/files/1/0736/0587/3972/files/Opal.jpg?v=1742030665',
    'Sapphire': 'https://cdn.shopify.com/s/files/1/0736/0587/3972/files/Sapphire.jpg?v=1742030666',
    'Pink Sapphire': 'https://cdn.shopify.com/s/files/1/0736/0587/3972/files/Pink_Sapphire.jpg?v=1742030665',
    'Emerald': 'https://cdn.shopify.com/s/files/1/0736/0587/3972/files/emerald.jpg?v=1742030665',
    'Pearl': 'https://cdn.shopify.com/s/files/1/0736/0587/3972/files/pearl-fil.jpg?v=1746433425',
    'Tanzanite': 'https://cdn.shopify.com/s/files/1/0736/0587/3972/files/tanzanite.jpg?v=1753188644',
    // Add more gemstones as needed
  };
  // Find all gemstone filter labels
  const gemstoneLabels = document.querySelectorAll('.cc-checkbox__label');
  gemstoneLabels.forEach(label => {
    const gemstoneName = label.textContent.trim();
    if (gemstoneImages[gemstoneName]) {
      // Replace text with an image, but add title attribute for tooltip
      label.innerHTML = `
        <div class="gemstone-image-container" style="display: flex; align-items: center; gap: 8px;">
          <img src="${gemstoneImages[gemstoneName]}" alt="${gemstoneName}" title="${gemstoneName}" style="width: 24px; height: 24px;">
        </div>
      `;
    }
  });
}

function addClassToGemStonesFilter() {
  // Find all filter titles
  const filterTitles = document.querySelectorAll('.cc-accordion-item__title');
  filterTitles.forEach(title => {
    if (title.textContent.trim() === 'Gem Stones') {
      // Add a class to the "Gem Stones" filter section
      const gemStonesFilterSection = title.closest('.cc-accordion-item');
      gemStonesFilterSection.classList.add('gem-stones-filter');
    }
  });
}

// Use MutationObserver to detect when filters are added or re-rendered
const observer = new MutationObserver((mutationsList, observer) => {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList') {
      // Check if filters are added or updated
      const filters = document.querySelector('.cc-accordion-item__content');
      if (filters) {
        replaceGemstoneTextWithImages();
        addClassToGemStonesFilter();
      }
    }
  }
});

// Start observing the document body for changes
observer.observe(document.body, { childList: true, subtree: true });

// Initial run in case filters are already loaded
replaceGemstoneTextWithImages();
addClassToGemStonesFilter();